import React, { useState, useEffect } from 'react';
import Navbar from './navbar';
import Footer from './footer';
import { useParams } from 'react-router-dom'; // Import useParams hook
import { StrategyService } from './services/strategyService'; // Import the API service
import ClosedTradesTable from './closedTradesTable';
import LiveTradesTable from './liveTradesTable';
import StrategyHighlightsTable from './strategyHighlightsTable'; // Import the new component
import DrawDownTable from './drawDownTable';
import { useNavigate,useLocation } from 'react-router-dom';

const StrategyDataManager = () => {
  const { strategyCode } = useParams(); // Get strategyCode from the URL
  const [strategyData, setStrategyData] = useState(null);
  const [openItem, setOpenItem] = useState('collapseOne');
  const [liveTradesFetched, setLiveTradesFetched] = useState(false);

  // Pagination state
  const [currentPageLive, setCurrentPageLive] = useState(1);
  const [itemsPerPageLive] = useState(15);
  const [currentPageClosed, setCurrentPageClosed] = useState(1);
  const [itemsPerPageClosed] = useState(15);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const navigate = useNavigate();
  const location = useLocation();
  const fromPreview = location.state?.fromPreview || false;

  const fetchStrategyDetails = async () => {
    try {
      const data = await StrategyService(strategyCode); // Use strategyCode from the URL
      setStrategyData(data.data.strategyDetails); // Store the response data in state
    } catch (error) {
      console.error('Error fetching strategy details:', error);
    }
  };

  useEffect(() => {
    fetchStrategyDetails();
  }, [strategyCode]);



  const fetchLiveTrades = async () => {
    try {
      const data = await StrategyService(strategyCode); // Pass strategyCode to the service for live trades as well
      setLiveTradesFetched(true); // Mark live trades as fetched
    } catch (error) {
      console.error('Error fetching live trades:', error);
    }
  };

  // Ensure liveTrades and closedTrades are arrays before slicing
  const liveTrades = Array.isArray(strategyData?.liveTrades) ? strategyData?.liveTrades : [];
  const closedTrades = Array.isArray(strategyData?.closedTrades) ? strategyData?.closedTrades : [];
  const strategyHighlights = strategyData?.strategyHighlights || {}; // Access strategy highlights
  const drawDown = strategyData?.drawdown || {}; 

  // Pagination logic for live trades
  const indexOfLastLiveTrade = currentPageLive * itemsPerPageLive;
  const indexOfFirstLiveTrade = indexOfLastLiveTrade - itemsPerPageLive;
  const currentLiveTrades = liveTrades.slice(indexOfFirstLiveTrade, indexOfLastLiveTrade);

  // Pagination logic for closed trades
  const indexOfLastClosedTrade = currentPageClosed * itemsPerPageClosed;
  const indexOfFirstClosedTrade = indexOfLastClosedTrade - itemsPerPageClosed;
  const currentClosedTrades = closedTrades.slice(indexOfFirstClosedTrade, indexOfLastClosedTrade);

  // Handle page change for live trades
  const paginateLive = (pageNumber) => setCurrentPageLive(pageNumber);

  // Handle page change for closed trades
  const paginateClosed = (pageNumber) => setCurrentPageClosed(pageNumber);

  const handleToggle = (id) => {
    if (openItem === id) {
      setOpenItem(''); // Close the item if it's already open
    } else {
      setOpenItem(id); // Open the clicked item
      if (id === 'collapseOne' && !strategyData) {
        fetchStrategyDetails();
      }
      if (id === 'collapseTwo' && !liveTradesFetched) {
        fetchLiveTrades();
      }
    }
  };

  const sortData = (data, key) => {
    console.log("Data before sorting:", data); // Debugging
    const direction = sortConfig.direction === 'asc' ? 1 : -1;
  
    const isValidKey = data.every(item => item.hasOwnProperty(key));
    if (!isValidKey) {
      console.warn(`Key '${key}' does not exist in all items`);
    }
  
    return [...data].sort((a, b) => {
      const aValue = a[key]?.toString().toLowerCase() || ''; // Normalize for case-insensitivity
      const bValue = b[key]?.toString().toLowerCase() || '';
  
      console.log(`Comparing '${aValue}' with '${bValue}'`);
      if (aValue < bValue) return -1 * direction;
      if (aValue > bValue) return 1 * direction;
      return 0;
    });
  };

  const requestSort = (key) => {
    console.log("Requesting sort for", key);
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const renderSortArrow = (column) => {
    if (sortConfig.key === column) {
      return sortConfig.direction === 'asc' ? '↑' : '↓';
    }
    return '';
  };
  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
         

               {/* Left-aligned Back Button */}
          <div className='d-flex justify-content-between' style={{ marginBottom: '10px' }}>
            <button className="btn btn-primary d-flex justify-content-start" onClick={() => navigate(-1)}>
              Back
            </button>
            <h4>Strategy Data Manager</h4>
            <h1></h1>
          </div>


          <div id="accordion">
            {/* Strategy Details Section */}
            <div className="card">
              <div className="card-header">
                <button
                  className="btn d-grid gap-2 d-md-block fw-bold"
                  type="button"
                  onClick={() => handleToggle('collapseOne')}
                  aria-expanded={openItem === 'collapseOne' ? 'true' : 'false'}
                >
                  Strategy Details {">"}
                </button>
              </div>
              <div id="collapseOne" className={`collapse ${openItem === 'collapseOne' ? 'show' : ''}`} aria-labelledby="headingOne">
                <div className="card-body">
                  {strategyData ? (
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Strategy Code</th>
                          <th>Net Returns</th>
                          <th>xirr</th>
                          <th>PnL</th>
                          <th>Status</th>
                          <th>Created On</th>
                          <th>Modified On</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{strategyData.strategyCode}</td>
                          <td>{strategyData.netReturns}</td>
                          <td>{strategyData.xirr || 'N/A'}</td>
                          <td>{strategyData.pnl}</td>
                          <td>{strategyData.status}</td>
                          <td>{strategyData.createdOn || 'N/A'}</td>
                          <td>{strategyData.modifiedOn || 'N/A'}</td>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <p>Loading strategy details...</p>
                  )}
                </div>
              </div>
            </div>

            {/* Strategy Highlights Section */}
            <div className="card">
              <div className="card-header">
                <button
                  className="collapsed btn d-grid gap-2 d-md-block fw-bold"
                  type="button"
                  onClick={() => handleToggle('collapseThree')}
                  aria-expanded={openItem === 'collapseThree' ? 'true' : 'false'}
                >
                  Strategy Highlights {">"}
                </button>
              </div>
              <div id="collapseThree" className={`collapse ${openItem === 'collapseThree' ? 'show' : ''}`} aria-labelledby="headingThree">
                <div className="card-body">
                  {/* Strategy Highlights Table */}
                  <StrategyHighlightsTable 
                   strategyHighlights={strategyData?.strategyHighlights} 
                   sdCode={strategyCode}  />
                </div>
              </div>
            </div>

            {/* Live Trades Section */}
            <div className="card">
              <div className="card-header">
                <button
                  className="collapsed btn d-grid gap-2 d-md-block fw-bold"
                  type="button"
                  onClick={() => handleToggle('collapseTwo')}
                  aria-expanded={openItem === 'collapseTwo' ? 'true' : 'false'}
                >
                  Live Trades {">"}
                </button>
              </div>
              <div id="collapseTwo" className={`collapse ${openItem === 'collapseTwo' ? 'show' : ''}`} aria-labelledby="headingTwo">
                <div className="card-body">
                  {/* Live Trades Table */}
                  <LiveTradesTable
                    liveTrades={liveTrades}
                    fromPreview={fromPreview}
                    currentPageLive={currentPageLive}
                    itemsPerPageLive={itemsPerPageLive}
                    paginateLive={paginateLive}
                    requestSort={requestSort}
                    sortConfig={sortConfig}
                    renderSortArrow={renderSortArrow}
                    prevStrategyCode={strategyCode}
                  />
                </div>
              </div>
            </div>

            {/* Closed Trades Section */}
            <div className="card">
              <div className="card-header">
                <button
                  className="collapsed btn d-grid gap-2 d-md-block fw-bold"
                  type="button"
                  onClick={() => handleToggle('collapseFour')}
                  aria-expanded={openItem === 'collapseFour' ? 'true' : 'false'}
                >
                  Closed Trades {">"}
                </button>
              </div>
              <div id="collapseFour" className={`collapse ${openItem === 'collapseFour' ? 'show' : ''}`} aria-labelledby="headingFour">
                <div className="card-body">
                  {/* Closed Trades Table */}
                  <ClosedTradesTable
                    closedTrades={closedTrades}
                    fromPreview={fromPreview}
                    currentPageClosed={currentPageClosed}
                    itemsPerPageClosed={itemsPerPageClosed}
                    paginateClosed={paginateClosed}
                    requestSort={requestSort}
                    sortConfig={sortConfig}
                    renderSortArrow={renderSortArrow}
                    prevStrategyCode={strategyCode}
                  />
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header">
                <button
                  className="btn d-grid gap-2 d-md-block fw-bold"
                  type="button"
                  onClick={() => handleToggle('collapseDrawdown')}
                  aria-expanded={openItem === 'collapseDrawdown' ? 'true' : 'false'}
                >
                  Drawdown {" > "}
                </button>
              </div>
              <div
                id="collapseDrawdown"
                className={`collapse ${openItem === 'collapseDrawdown' ? 'show' : ''}`}
                aria-labelledby="headingDrawdown"
              >
                <div className="card-body">
                  {/* Drawdown Table */}
                  <DrawDownTable drawDownData={drawDown  } />
                </div>
              </div>
             </div> 
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default StrategyDataManager;
